var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tab-progress-container" }, [
    _c("div", { staticClass: "tabs d-md-block d-none" }, [
      _c(
        "div",
        { staticClass: "tab-container" },
        _vm._l(_vm.tabs, function(tab, index) {
          return _c(
            "div",
            {
              key: tab.id + index,
              staticClass: "tab",
              class: { selected: _vm.activeTabId === tab.id },
              on: {
                click: function($event) {
                  return _vm.handleTabClick(tab.id)
                }
              }
            },
            [_vm._v("\n\t\t\t\t" + _vm._s(tab.title) + "\n\t\t\t")]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tabs mobile d-md-none d-flex" }, [
      _c(
        "div",
        { staticClass: "back-button", on: { click: _vm.goBack } },
        [
          _c("InlineSvg", {
            staticClass: "back-icon",
            attrs: { src: "/images/icons/ic-chevron-left.svg" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-container" },
        _vm._l(_vm.tabs, function(tab, index) {
          return _c(
            "div",
            {
              key: tab.id + index,
              staticClass: "tab mobile",
              class: { selected: _vm.activeTabId === tab.id },
              on: {
                click: function($event) {
                  return _vm.handleTabClick(tab.id)
                }
              }
            },
            [_vm._v("\n\t\t\t\t" + _vm._s(tab.title) + "\n\t\t\t")]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "progress-line-wrapper d-none d-md-block" }, [
      _c("div", { staticClass: "progress-line" }, [
        _c("div", {
          staticClass: "progress-fill",
          style: { width: _vm.fillWidth + "%" }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "indicators" },
        _vm._l(_vm.tabs, function(tab, index) {
          return _c(
            "div",
            {
              key: "indicator-" + tab.id + index,
              staticClass: "indicator-wrapper"
            },
            [
              _c(
                "div",
                {
                  staticClass: "indicator",
                  class: {
                    complete: _vm.touchedTabs.includes(tab.id) && !tab.invalid,
                    selected: _vm.activeTabId === tab.id
                  }
                },
                [
                  _vm.touchedTabs.includes(tab.id) && !tab.invalid
                    ? _c("InlineSvg", {
                        attrs: { src: "/images/icons/ic-check.svg" }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }